import { Role } from 'shared/data/walletsKyc/v1';

import { DetailsStep } from './components/DetailsStep/DetailsStep';
import { schema as detailsStepSchema } from './components/DetailsStep/DetailsStep.schema';
import { DocumentStep } from './components/DocumentStep/DocumentStep';
import { schema as documentStepSchema } from './components/DocumentStep/DocumentStep.schema';
import { RoleStep } from './components/RoleStep/RoleStep';
import { AdoptedRole } from './components/RoleStep/RoleStep.constants';
import { schema as roleStepSchema } from './components/RoleStep/RoleStep.schema';

export const adoptedRoleToRoles = {
    [AdoptedRole.Director]: [Role.director],
    [AdoptedRole.Owner]: [Role.ultimate_business_owner],
    [AdoptedRole.DirectorWithOwnership]: [Role.director, Role.ultimate_business_owner],
};

export type AddPersonWizardStep = 'role' | 'details' | 'document';

export const addPersonWizardSteps: AddPersonWizardStep[] = ['role', 'details', 'document'];

export const addPersonWizardStepComponentsMap = <const>{
    role: RoleStep,
    details: DetailsStep,
    document: DocumentStep,
};

export const addPersonWizardStepSchemaMap = {
    role: roleStepSchema,
    details: detailsStepSchema,
    document: documentStepSchema,
};

const detailsStepFields = [
    'adoptedRoles',
    'ownershipPercentage',
    'verifyNeeded',
    'firstName',
    'middleName',
    'lastName',
    'email',
] as const;

const documentStepFields = [...detailsStepFields, 'dob', 'address', 'phoneNumber', 'isUs'] as const;

export const stepToFieldsMap = {
    details: detailsStepFields,
    document: documentStepFields,
};
